import React from 'react';

export class Asterisk extends React.Component {
  render() {
    if (this.props.required) {
      return <span style={ {color: 'red'} }> * </span>;
    } else {
      return <div/>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/asterisk.jsx